import { Form } from "antd";
import { useReducer, useEffect, useMemo } from "react";
import { columnsAreasUser } from "../../types/columnsTables/columnArea";
import { MessageAnt } from "../../redux/slices/ui/uiAction";
import { MessageType } from "../../types/messageType";
import {
    createRequestAreasInmersys,
    deleteRequestAreasInmersys,
    editRequestAreasInmersys,
    editRequestTeamAreasInmersys,
    getRequestAreasInmersys,
} from "../../config";

const initialState = {
    isLoading: false,
    searchValue: "",
    tableData: [],
    tablePagination: 0,
    activeModal: false,
    typeModal: 0,
    dataForm: {},
    selectedArea: "",
    loadingButton: false,
    color: "#bc2929",
    id: "",
};

function reducer(state, action) {
    switch (action.type) {
        case "SET_LOADING":
            return { ...state, isLoading: action.payload };
        case "SET_SEARCH_VALUE":
            return { ...state, searchValue: action.payload };
        case "SET_TABLE_DATA":
            return { ...state, tableData: action.payload };
        case "SET_TABLE_PAGINATION":
            return { ...state, tablePagination: action.payload };
        case "SET_ACTIVE_MODAL":
            return { ...state, activeModal: action.payload };
        case "SET_TYPE_MODAL":
            return { ...state, typeModal: action.payload };
        case "SET_DATA_FORM":
            return { ...state, dataForm: action.payload };
        case "SET_SELECTED_AREA":
            return { ...state, selectedArea: action.payload };
        case "SET_LOADING_BUTTON":
            return { ...state, loadingButton: action.payload };
        case "SET_COLOR":
            return { ...state, color: action.payload };
        case "SET_ID":
            return { ...state, id: action.payload };
        default:
            throw new Error(`Unknown action type: ${action.type}`);
    }
}

export const usePageAreasData = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [form] = Form.useForm();

    const getAllAreaUser = async () => {
        dispatch({ type: "SET_LOADING", payload: true });
        const { status, payload } = await getRequestAreasInmersys();
        if (status > 0) {
            MessageAnt(MessageType.error, `Error de servidor`);
            dispatch({ type: "SET_LOADING", payload: false });
            return;
        }
        const { areas, teamAreas } = payload;
        const areaTable = []
        areas.forEach(area => {
            if (teamAreas.includes(area._id)) {
                areaTable.unshift(area)
            } else {
                areaTable.push(area)
            }
        })

        const newAreas = areaTable.map((area) => {
            return {
                key: area._id,
                ...area,
            };
        });
        dispatch({ type: "SET_TABLE_DATA", payload: newAreas });
        dispatch({ type: "SET_TABLE_PAGINATION", payload: newAreas.length });
        dispatch({ type: "SET_LOADING", payload: false });
    };

    const createAreaUser = async (form) => {
        const { status } = await createRequestAreasInmersys(form);
        getAllAreaUser();
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: true });
        if (status > 0) {
            MessageAnt(MessageType.error, `Error al crear areas`);
        } else {
            MessageAnt(MessageType.success, `Se creo area`);
        }
        dispatch({ type: "SET_LOADING_BUTTON", payload: false });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
    };

    const editAreaUser = async (form) => {
        const { status } = await editRequestAreasInmersys(state.id, form);
        getAllAreaUser();
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: true });

        if (status > 0) {
            MessageAnt(MessageType.error, `Error al editar areas`);
        } else {
            MessageAnt(MessageType.success, `Se edito area ${state.dataForm.name}`);
        }
        dispatch({ type: "SET_LOADING_BUTTON", payload: false });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
    };

    const deleteAreaUser = async (id) => {
        const { status, payload } = await deleteRequestAreasInmersys(id);
        if (status > 0) {
            console.log(payload);
            MessageAnt(MessageType.error, `Error al editar areas`);
        } else {
            MessageAnt(MessageType.success, `Se elimino area`);
        }
        await getAllAreaUser();
    };

    const updateTeamUser = async (id, value) => {
        try {
            let number = 0;
            if (!value) {
                number = 1;
            }
            const { status, payload } = await editRequestTeamAreasInmersys(id, number);
            if (status > 0) {
                console.log(payload);
                MessageAnt(MessageType.error, `Error al editar areas`);
            } else {
                MessageAnt(MessageType.success, `Se elimino area`);
            }
        } catch (error) {
            console.log(error);
            MessageAnt(MessageType.error, `Error de servidor`);
        } finally {
            getAllAreaUser();
        }
    };

    const editAction = (form, id) => {
        if (form) {
            dispatch({ type: "SET_DATA_FORM", payload: { ...form } });
            dispatch({ type: "SET_SELECTED_AREA", payload: form.name });
            dispatch({ type: "SET_ID", payload: id });
        }

        dispatch({ type: "SET_TYPE_MODAL", payload: 1 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: true });
    };

    const changeColor = ({ target }) => {
        dispatch({ type: "SET_COLOR", payload: target.value });
    };

    const onFinish = (values) => {
        dispatch({ type: "SET_LOADING_BUTTON", payload: true });
        let structureForm;

        if (values.name.toLowerCase() === state.dataForm.name.toLowerCase()) {
            structureForm = { color: state.color };
        } else {
            structureForm = {
                ...values,
                color: state.color,
            };
        }
        if (state.typeModal === 0) {
            createAreaUser(structureForm);
        } else {
            editAreaUser(structureForm);
        }
    };

    const handleOpenModalCreate = () => {
        dispatch({ type: "SET_DATA_FORM", payload: { isActive: true, name: "" } });
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: true });
    };

    const closeModal = () => {
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
    };

    const handleChange = (e) => {
        dispatch({ type: "SET_SEARCH_VALUE", payload: e.target.value });
    };

    const { columns, props } = columnsAreasUser(editAction, deleteAreaUser, state.tablePagination, updateTeamUser);
    const { pagination, ...tableProps } = props;

    const tableFilterDataAreas = useMemo(() => {
        return state.tableData.filter((item) => {
            let isFilter = [];
            isFilter.push(item.name.toLocaleLowerCase().includes(state.searchValue.toLocaleLowerCase()));
            return isFilter.every((value) => value);
        });
    }, [state.tableData, state.searchValue]);

    useEffect(() => {
        getAllAreaUser();
    }, []);

    useEffect(() => {
        if (!state.dataForm.color) return;
        dispatch({ type: "SET_COLOR", payload: state.dataForm.color });
        form.setFieldsValue({
            ...state.dataForm,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.dataForm]);

    return {
        changeColor,
        color: state.color,
        searchValue: state.searchValue,
        activeModal: state.activeModal,
        typeModal: state.typeModal,
        loadingButton: state.loadingButton,
        form,
        isLoading: state.isLoading,
        handleOpenModalCreate,
        closeModal,
        onFinish,
        tableFilterDataAreas,
        handleChange,
        columns,
        tableProps,
        pagination,
        tablePagination: state.tablePagination,
    };
};
